module.exports = __webpack_public_path__ + "img/hero.1e150218.png";